import { SET_IS_LOADING_SUCCESS } from '../actions/loading'

const auth = (state = { isLoading: false }, action) => {
  switch (action.type) {
    case SET_IS_LOADING_SUCCESS:
      return { isLoading: action.data.isLoading }
    default:
      return state
  }
}

export default auth


// WEBPACK FOOTER //
// ./src/reducers/loading.js